import { Check } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

import type { PresetRange } from '../../lib/date-utils';

interface PresetButtonProps {
  preset: PresetRange;
  isSelected: boolean;
  onSelect: () => void;
}

/**
 * Full width only in the sidebar's column layout. On narrow screens the presets
 * are a horizontally scrollable row, and `w-full` there made every button claim
 * the whole line — so only the first one was ever on screen.
 */
export function PresetButton({ preset, isSelected, onSelect }: PresetButtonProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn('shrink-0 justify-between mb-1 sm:w-full', isSelected && 'bg-accent')}
      onClick={onSelect}>
      <span className="text-sm">{preset.label}</span>
      {isSelected && <Check className="h-3 w-3 text-primary" />}
    </Button>
  );
}
